import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'styled-components';
import makeThemedComponent from '../../utils/makeThemedComponent';

const defaultStyles = css`
  border: 2px solid #000;
  border-radius: 0;
  padding: 0.5rem;
`;

/**
 * Renders an `input` element with some default styles.
 *
 * @public
 * @author Connor Taylor
 */
const SingleLineInput = makeThemedComponent({
  themeKey: `TextInput`,
  component: `input`,
  defaultStyles,
});

const MultilineInput = SingleLineInput.withComponent(`textarea`);

class TextInput extends Component {
  render() {
    const { multiline, ...rest } = this.props;

    return this.props.multiline ? (
      <MultilineInput {...rest} />
    ) : (
      <SingleLineInput {...rest} />
    );
  }
}

TextInput.propTypes = {
  multiline: PropTypes.bool,
};

export { defaultStyles };

/** @component */
export default TextInput;
